//import './thank-you.scss'
//import { useRedirectToStepper } from '@ui/pages/thank-you/hooks/redirect.hook.ts'
//import { useDocumentsAvailable } from '@ui/pages/thank-you/hooks/use-documents.hook.ts'
import { Title } from '@ui/components/title'
//import { DocumentContainer } from '@ui/pages/thank-you/components/document-card.component.tsx'
import { BoxComponent, BoxSelectorComponent } from '@ui/components/box-selector'

import { ModalContextProvider } from '@store/modal.tsx'
import { useAppContext } from '@hooks/use-app-context.ts'
//import { UploadDocuments } from '@ui/pages/thank-you/components/upload-documents.component.tsx'
import { Button } from '@ui/components/button'
import { Actions } from '@store/reducer.ts'
import clsx from 'clsx'
import { isDeviceMobile } from '@utils/mobile'
import { useEffect, useMemo, useRef } from 'react'
import { useModUnico } from '@hooks/use-mod-unico.hook'
import { scrollToTop } from '@utils/iframe'
import { forceScrollHeight, useFrameResize } from '@hooks/use-resize'
import { useApi } from '@hooks/use-api-requests.hook'
import { type State } from '@store/defaultReducerState'

import {
	analyticsCurrentAction,
	showMobileUploadThankYou,
} from '@store/atoms.ts'
import { useAtom, useSetAtom } from 'jotai'
import { isDevEnv } from '@utils/debug.ts'
import { useDocumentsAvailable } from './hooks/use-documents.hook'
import type { UserDocument } from '@hooks/type-ds'
import Loader from '@ui/components/loader'
import { useRedirectToStepper } from './hooks/redirect.hook'
import { MobileUploadPage } from '../mobile-upload/mobile-upload.page'
import { DocumentContainer } from './components/document-card.component'
import { UploadDocuments } from './components/upload-documents.component'

export const DonePage = () => {
	const setAnalyticsAction = useSetAtom(analyticsCurrentAction)
	const { state } = useAppContext()
	const { documents: documentsUploaded, isFetchingDocuments } =
		useDocumentsAvailable()
	const isIbanPresent = useMemo(() => state.data.Four.IBAN !== '', [])
	const areDocsUploaded = useMemo(
		() => documentsUploaded?.length === 3,
		[documentsUploaded]
	)
	const showPartial = !isIbanPresent || !areDocsUploaded
	const conjunctions = !isIbanPresent && !areDocsUploaded

	const altroTitle = useModUnico()
	const documents: Array<{ id: UserDocument; title: string }> = [
		{
			id: 'IDE',
			title:
				state.data.Three.Document.DocumentType === 'IDE'
					? 'Carta di identità'
					: 'Patente',
		},
		{
			id: 'CF',
			title: 'Codice fiscale',
		},
		{
			id: 'ALTRO',
			title: altroTitle,
		},
	]

	const IBANSentence = useMemo(
		() => (isIbanPresent ? 'caricare' : 'caricare il tuo IBAN'),
		[]
	)
	const DocsSentence = useMemo(
		() =>
			areDocsUploaded
				? ''
				: `i documenti mancanti (${documents
						.filter((e) => !documentsUploaded?.includes(e.id))
						.map((e) => e.title)
						.toString()
						.split(',')
						.join(', ')})`,
		[documentsUploaded, altroTitle]
	)

	useEffect(() => {
		if (documentsUploaded) {
			if (!isIbanPresent && !areDocsUploaded) {
				setAnalyticsAction('TnkYouOKnoAllnoIBAN')
			} else if (!isIbanPresent) {
				setAnalyticsAction('TnkYouOKnoIBAN')
			} else if (!areDocsUploaded) {
				setAnalyticsAction('TnkYouOKnoAll')
			} else {
				setAnalyticsAction('TnkYouOKFine')
			}
		}
	}, [documentsUploaded])

	return (
		<section className={'done-container'}>
			{isFetchingDocuments ? (
				<Loader isOpen/>
			) : (
				<>
					<img src={'/assets/images/spunta.png'} />
					<Title>
						{!areDocsUploaded ? 'Manca poco' : 'Complimenti'}! Hai{' '}
						{showPartial ? 'quasi completato' : 'completato correttamente'} la
						tua richiesta
					</Title>
					<p className={'done-container__description'}>
						Accedi all'Area Riservata per{' '}
						<b>
							{showPartial
								? `${IBANSentence}${conjunctions ? ', ' : ' '}${DocsSentence}`
								: ''}
						</b>
						{showPartial ? ' e' : ''}
						{!areDocsUploaded ? ', in seguito, ' : ' '}
						monitorare lo stato di avanzamento della tua richiesta.
					</p>
					<p
						className={
							'done-container__description done-container__description--margin'
						}
					>
						Se i documenti caricati non fossero subito visibili, non
						preoccuparti, lo saranno presto.
					</p>
					<Button
						disabled={false}
						label={"Vai all' area riservata"}
						onClick={() =>
							window.open(import.meta.env.VITE_END_REDIRECT, '_blank')
						}
					/>
				</>
			)}
		</section>
	)
}

const ThanksPage = () => {
	useRedirectToStepper() //  redirects use to stepper if IdRichiesta has not been initiated
	const { state, dispatch } = useAppContext()

	const {
		documents: documentsUploaded,
		isFetchingDocuments,
		triggerFetchDocuments,
	} = useDocumentsAvailable()
	const modelloUnico = useModUnico()
	const docsRequiredToPass: Array<UserDocument> = ['ALTRO', 'CF', 'IDE']
	const [mobileView, setMobileView] = useAtom(showMobileUploadThankYou)
	const setAnalyticsAction = useSetAtom(analyticsCurrentAction)

	useEffect(() => {
		scrollToTop()
		forceScrollHeight()
	}, [])

	useEffect(() => {
		// if new files have been uploaded, refetch documents
		triggerFetchDocuments({})
	}, [state.files])

	const containerRef = useRef(null)
	useFrameResize(containerRef)

	const [OCSInfos, sendDocuments, isFetchingOCS] = useApi<State['ocs']>({
		request: 'DbOperations/SendDocuments',
		method: 'POST',
		sleeper: true,
	})

	console.log("OCSINFO",OCSInfos)
	// eslint-disable-next-line
	const [_, sendFPG, isFetchingGesudo] = useApi({
		request: 'DbOperations/SendToFPgesudo',
		method: 'POST',
		sleeper: true,
	})

	const onMobileUpload = () => {
		setAnalyticsAction('TnkYou_FotografaDocumenti')
		setMobileView(true)
	}

	useEffect(() => {
		if (!isDevEnv) {
			sendDocuments({})
		}
	}, [])

	useEffect(() => {
		if (OCSInfos) {
			sendFPG({
				body: {
					NumeroPratica: OCSInfos.NumeroPratica?.toString(),
					CodiceControparte: OCSInfos.Controparte?.toString(),
				},
			})

			dispatch({
				type: Actions.UpdateOCS,
				payload: OCSInfos,
			})
		}
	}, [OCSInfos])

	useEffect(() => {
		if (
			documentsUploaded &&
			docsRequiredToPass.every((value) => documentsUploaded.includes(value))
		) {
			dispatch({
				type: Actions.SetThanksDone,
				payload: true,
			})
		}
	}, [documentsUploaded])

	useEffect(() => {
		if (!mobileView) {
			triggerFetchDocuments({})
		}
	}, [mobileView])

	if (state.data?.Thanks?.done) {
		//fix javascript error , insert optional chaining
		return <DonePage />
	}

	if (mobileView) {
		return <MobileUploadPage isOnMobile={false} />
	}

	if (isFetchingDocuments || isFetchingGesudo || isFetchingOCS) {
		return (
			<ModalContextProvider currentModal={state.ui.modal}>
				<div className='main-container' ref={containerRef}>
					<div style={{ marginTop: '50dvh' }}>
						<Loader isOpen />
					</div>
				</div>
			</ModalContextProvider>
		)
	}

	return (
		<ModalContextProvider currentModal={state.ui.modal}>
			<div className='main-container' ref={containerRef}>
				<section className='thankyou__main-container revert-container'>
					<div className='thankyou__main-container__header'>
						<div style={{ marginTop: '10px' }}></div>
						<Title>Ci sei quasi!</Title>
						<p>
							Carica subito i documenti mancanti necessari al completamento
							della richiesta, così potremo procedere con la valutazione e
							fornirti rapidamente l'esito.
						</p>
						<div className={'thankyou__main-container__documents'}>
							<DocumentContainer
								documents={[
									{
										id: 'IDE',
										title:
											state.data.Three.Document.DocumentType === 'IDE'
												? 'Carta di identità'
												: 'Patente',
									},
									{
										id: 'CF',
										title: 'Codice fiscale',
									},
									{
										id: 'ALTRO',
										title: modelloUnico,
									},
								]}
								source={documentsUploaded ?? []}
							/>
						</div>
					</div>
					<div
						className={clsx('thankyou__main-container__upload', {
							'thankyou__main-container__upload-spacing': !isDeviceMobile(),
						})}
					>
						<UploadDocuments onMobileUploadSelected={onMobileUpload} />
						<BoxSelectorComponent
							title={'Carica in seguito'}
							desktopDescription={
								'Carica i documenti in un altro momento nella tua Area Riservata, hai tempo 7 giorni!'
							}
						>
							<BoxComponent
								desktopTitle={'Invia in seguito'}
								icon={'clessidra.svg'}
								action={() => {
									dispatch({
										type: Actions.SetThanksDone,
										payload: true,
									})
								}}
							/>
						</BoxSelectorComponent>
					</div>
				</section>
			</div>
			{/*<Analytics stepRegistration={false} />*/}
		</ModalContextProvider>
	)
}

export default ThanksPage
